import { jsx as _jsx } from "react/jsx-runtime";
import MuiLink from '@mui/material/Link';
import * as React from 'react';
import { usePaletteColor } from '../theme';
import { prepareTextTransform } from '../typography';
export const Link = React.forwardRef((props, ref) => {
    const { color = 'primary', variant = 'body2', textTransform, children, ...muiProps } = props;
    const paletteColor = usePaletteColor(color);
    const cssTextTransform = textTransform === 'sentence' ? undefined : textTransform;
    return (_jsx(MuiLink, { ref: ref, underline: "hover", ...muiProps, variant: variant, textTransform: cssTextTransform, sx: {
            color: paletteColor,
            '&:hover': {
                color: paletteColor
            },
            cursor: props.onClick ? 'pointer' : undefined,
            ...muiProps.sx
        }, children: prepareTextTransform(children, textTransform) }));
});
